{
  "activities": {
    "accessoryProvider": "Accessory provider",
    "accessoryRawMaterialProvider": "Raw material provider",
    "apparel": {
      "duvet": {
        "baffle": "Baffle",
        "farm": "Breeding farm",
        "materialProduction": "Raw material",
        "preProcessor": "Pre-processing"
      },
      "fabric": {
        "appret": "Finishing",
        "coating": "Coating",
        "dyeing": "Dyeing/Printing",
        "lamination": "Lamination",
        "materialProduction": "Raw material",
        "spinning": "Spinning",
        "weavingKnitting": "Weaving/Knitting"
      },
      "leather": {
        "appret": "Finishing",
        "dyeing": "Dyeing",
        "farm": "Breeding farm",
        "materialProduction": "Slaughterhouse",
        "tanning": "Tanning"
      },
      "manufacturing": "Manufacturing",
      "yarn": {
        "dyeing": "Dyeing",
        "materialProduction": "Raw material",
        "spinning": "Spinning"
      }
    },
    "brand": "Brand",
    "certifiedEntity": "Certified entity",
    "footwear": {
      "assembling": "Assembling",
      "finishing": "Finishing",
      "stitching": "Stitching"
    },
    "noActivity": "No activity",
    "paper": {
      "assembling": "Assembly",
      "bleaching": "Bleaching",
      "chemicalTreatment": "Chemical treatment",
      "laminating": "Laminating",
      "manufacturing": "Manufacturing",
      "pressing": "Pressing",
      "printing": "Printing",
      "resineRemoving": "Resine removing",
      "whiteWashing": "White washing"
    },
    "product": {
      "productWashing": "Product washing",
      "washing": "Washing"
    },
    "wood": {
      "assembling": "Assembly",
      "brushing": "Brushing",
      "calibrationAndCollage": "Calibration and collage",
      "harvesting": "Harvesting",
      "manufacturing": "Manufacturing",
      "materialDrying": "Drying",
      "materialPeeking": "Peeking",
      "materialPeeling": "Peeling",
      "materialSawing": "Sawing",
      "sanding": "Sanding"
    }
  },
  "batchModal": {
    "actions": {
      "selectEmpty": "Select empty"
    },
    "applyButton": "Apply this value to {{ itemCount }} selected items.",
    "batchUpdateSuccess": "Update successful",
    "batchUpdateSuccessMessage_one": "Request updated",
    "batchUpdateSuccessMessage_many": "{{count}} requests updated",
    "batchUpdateSuccessMessage_other": "{{count}} requests updated",
    "info": "There are <b>{{count}}</b> other items with the activity <b><activity/><b>",
    "labels": {
      "certificate": "Certificate",
      "clientName": "Client",
      "componentName": "Label",
      "componentReference": "Reference",
      "contact": "Contact",
      "documentProof": "Digital proof",
      "informationRequestItemReference": "Request",
      "informationRequestItemReferenceHint": "Reference of the associated product, component, or material.",
      "materialName": "Material",
      "materialProportion": "Proportion",
      "materialReference": "Reference",
      "productCollection": "Collection",
      "productColor": "Color",
      "productId": "ID",
      "productionSite": "Production site",
      "productName": "Label",
      "productReference": "Reference",
      "purchaseOrder": "Purchase order",
      "purchaseOrderRef": "Purchase order",
      "reference": "Reference"
    },
    "noDocument": "No document",
    "searchProduct": "Search",
    "title": "Batch update"
  },
  "batchPopover": {
    "button": "Reuse",
    "certificateText": "Apply this certificate to multiple requests?",
    "text": "Apply this value to multiple <activity />?"
  },
  "certificateBatchModal": {
    "labels": {
      "certificate": "Certificate",
      "products": "Products",
      "type": "Type"
    },
    "success_one": "{{count}} certificate request updated successfully",
    "success_many": "{{count}} certificate requests updated successfully",
    "success_other": "{{count}} certificate requests updated successfully"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "Accepted",
    "OPENED": "Open",
    "REJECTED": "Rejected",
    "SUBMITTED": "Pending"
  },
  "certificates": {
    "actions": {
      "delete": "Delete",
      "submit": "Submit",
      "transfer": "Transfer"
    },
    "activityName": "Traceability step:",
    "labels": {
      "maxIssueDate": "Maximum issue date",
      "purchaseOrder": "Transaction ID (PO or invoice)"
    },
    "modal": {
      "areyousure": "Are you sure you want to delete this certificate (this action is permanent)?",
      "no": "No",
      "yes": "Yes, delete"
    },
    "noRequests": {
      "closed": "You have no completed certificate requests.",
      "open": "You have no pending certificate requests."
    },
    "productionSite": "Production site",
    "productionSitePending": "Production site information pending",
    "purchaseOrder": {
      "actions": {
        "seeLess": "Hide",
        "seeMore": "Show"
      },
      "productReferences": "References"
    },
    "reference": "Reference: {{reference}}",
    "select": {
      "placeholder": "Select a document from your uploads."
    },
    "upload": {
      "title": "Upload certificate"
    }
  },
  "contactModal": {
    "businessPartnerRepository": {
      "addressUnavailable": "Address unavailable",
      "createNewOption": "Create new: \"{{term}}\"",
      "prefillLoadError": "Couldn't load company details from the directory. You can still edit the form manually.",
      "prefillLoadErrorTitle": "Prefill unavailable"
    },
    "labels": {
      "companyCity": "City",
      "companyCityPlaceholder": "Paris",
      "companyCityTooltip": "City of the company",
      "companyCountry": "Country",
      "companyCountryTooltip": "Country of the company",
      "companyIsActive": "Active",
      "companyIsActivePlaceholder": "Active",
      "companyIsActiveTooltip": "Identify business partners currently active and available for trade.",
      "companyName": "Company name",
      "companyNamePlaceholder": "Trace for good",
      "companyNameTooltip": "Public name of the business partner company.",
      "companyPostalCode": "Postal code",
      "companyPostalCodePlaceholder": "75000",
      "companyPostalCodeTooltip": "Postal code of the company",
      "companyRegistrationId": "Company registration ID",
      "companyRegistrationIdDescription": {
        "DUNS": "Unique 9-digit identifier issued by Dun & Bradstreet, commonly used in the US and for international trade. Format: 9-digit numeric code.",
        "EORI": "Identification number for businesses involved in EU customs activities. Format: country code (e.g., FR) + 14-digit SIRET number.",
        "GLN": "Global Location Number - unique identifier for company locations or legal entities under GS1 standard. Format: 13-digit numeric code.",
        "OTHER": "Unique identifier of the company",
        "RCS": "RCS (numéro du registre du commerce): RCS + city + SIREN.",
        "VAT": "European tax identification number for companies liable to VAT. Format: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
      },
      "companyRegistrationIdPlaceholder": "1234567890",
      "companyRegistrationIdTooltip": "VAT Number, CIN, GSTIN, USC, etc.",
      "companyRelationshipType": {
        "AGENT": "Agent",
        "BRAND": "Brand",
        "MANUFACTURER": "Manufacturer",
        "OTHER": "Other",
        "RAW_MATERIAL_SUPPLIER": "Raw material supplier",
        "SUPPLIER": "Supplier",
        "TRADER": "Trader"
      },
      "companyRelationshipTypeName": "Type",
      "companyRelationshipTypeTooltip": "Nature of the partner company used to identify its role within the supply chain.",
      "companyStreet": "Street",
      "companyStreetPlaceholder": "1 av. des Champs Elysées",
      "companyStreetTooltip": "Street of the company",
      "companySupplierCode": "Supplier code",
      "companySupplierCodePlaceholder": "1234567890",
      "companySupplierCodeTooltip": "Short internal identification code for the business partner.",
      "contactInformation": "Contact information",
      "coordinates": "Coordinates",
      "coordinatesPlaceholder": "Enter the coordinates",
      "email": "Email",
      "emailPlaceholder": "support@traceforgood.com",
      "emailTooltip": "Email address to contact the business partner company.",
      "name": "Name",
      "namePlaceholder": "John Doe",
      "nameTooltip": "Usual identification of the business partner, used for exchanges by email.",
      "preferredLanguage": "Preferred language",
      "tags": "Tags (beta)",
      "tagsPlaceholder": "Add tags...",
      "tagsTooltip": "Internal classification, rating or any other contextual information associated with this partner organisation."
    },
    "messages": {
      "create": {
        "error": "An error occurred while creating the partner: {{ error }}",
        "success": "You have created a new partner with the contact {{ email }}"
      },
      "update": {
        "success": "You have updated the partner with the contact {{ email }}"
      }
    }
  },
  "contactSelect": {
    "labels": {
      "addNewContact": "New",
      "contact": "Assignee",
      "you": "you"
    },
    "placeholders": {
      "contact": "Search"
    }
  },
  "contactTable": {
    "columns": {
      "activity": {
        "name": "Activity",
        "tooltip": "Last registered login from the partner."
      },
      "averageResponseTime": {
        "averageResponseTimeValue_one": "{{nbDays}} day",
        "averageResponseTimeValue_other": "{{nbDays}} days",
        "name": "Response time",
        "tooltip": "Average time taken to respond to information requests."
      },
      "certificateRequests": {
        "name": "Certificate requests"
      },
      "code": {
        "name": "Code",
        "tooltip": "Short internal identification code for the business partner."
      },
      "company": {
        "name": "Company",
        "tooltip": "Official public name of the business partner company."
      },
      "contactEmail": {
        "name": "Contact (email)",
        "tooltip": "Email of the primary contact within the partner company."
      },
      "contactName": {
        "name": "Contact (name)",
        "tooltip": "Name of the primary contact within the partner company."
      },
      "location": {
        "name": "Location",
        "tooltip": "Country of the business partner company"
      },
      "productionSiteRequests": {
        "name": "Production site requests",
        "received": "received"
      },
      "productionSites": {
        "name": "Production sites",
        "tooltip": "Count of sites declared by the business partner and count of distinct countries."
      },
      "productRequests": {
        "name": "Product requests"
      },
      "reminder": {
        "name": "Reminder",
        "tooltip": "Last reminder sent to the partner."
      },
      "requests": {
        "name": "Requests",
        "tooltip": "Answered requests from the partner."
      },
      "status": {
        "name": "Status",
        "tooltip": "Identify business partners currently active and available for trade."
      },
      "tags": {
        "name": "Tags",
        "tooltip": "Internal classification, rating or any other contextual information."
      },
      "type": {
        "name": "Type",
        "tooltip": "Nature of the partner company used to identify its role within the supply chain."
      }
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    }
  },
  "customFields": {
    "attachment": "Attachment",
    "updateCustomField": {
      "customField": {
        "message": "The value has been updated and shared with the requiring partner.",
        "title": "Update"
      },
      "customFieldProof": {
        "message": "The document has been uploaded and shared with the requiring partner.",
        "title": "Upload"
      }
    },
    "uploadCustomFieldProofTooltip": "Add a digital proof to back the provided information."
  },
  "deselectAll": "Deselect all",
  "errors": {
    "axiosMessage": "The following error occurred: {{message}} \n\n please try again or contact support@traceforgood.com if the error persists",
    "reinforcedTraceability": "You cannot assign yourself to this request, please transfer to the relevant person",
    "title": "Error"
  },
  "filters": {
    "client": "Client",
    "search": "Search",
    "status": {
      "canceled": "Canceled",
      "closed": "Closed",
      "opened": "Open",
      "placeholder": "Status"
    },
    "title": "Filters",
    "type": "Category"
  },
  "item": {
    "brand": "Brand",
    "client": "Client",
    "collection": "Collection",
    "color": "Color",
    "component": "Component",
    "date": "Order (date)",
    "marketLaunchDate": "Due date",
    "material_one": "Material",
    "material_other": "Materials",
    "name": "Label",
    "partOf": "Part of",
    "product": "Product",
    "purchaseOrderRef": "Order (reference)",
    "reference": "Reference",
    "type": "Category"
  },
  "itemType": {
    "component": "Component",
    "material": "Material",
    "product": "Product"
  },
  "launch": {
    "modal": {
      "cancel": {
        "button": "Cancel",
        "no": "No",
        "title": "Are you sure you want to cancel this traceability campaign?",
        "yes": "Yes, cancel"
      },
      "close": {
        "button": "Close"
      },
      "eligibleProducts": {
        "checkbox": "Add details for à façon products",
        "error": {
          "title": "Found errors in submitted file"
        },
        "infoBox": {
          "description": {
            "multiple": "The traceability campaign can begin today for {{eligibleProductsCount}} products, bringing your traced product coverage rate to {{estimatedTraceabilityCoverage}}%",
            "single": "The traceability campaign can begin today for 1 product, bringing your traced product coverage rate to {{estimatedTraceabilityCoverage}}%"
          },
          "title": {
            "multiple": "{{eligibleProductsCount}} eligible products",
            "single": "1 eligible product"
          }
        },
        "launchButton": {
          "label": {
            "multiple": "Trace {{eligibleProductsCount}} products",
            "none": "Trace products",
            "single": "Trace 1 product"
          }
        }
      },
      "fullTraceability": {
        "infoBox": {
          "description": "All products in your catalog are currently traced to support your CSR strategy and legal compliance.",
          "title": "Congratulations"
        }
      },
      "header": {
        "description": {
          "default": "Trace for good currently collects information from your business partners for {{tracedProductsCount}}/{{totalProducts}} ({{currentTraceabilityCoverage}}%) products of your catalog",
          "noTraceabilityCampaign": "Launch your traceability campaign and start collecting information from your business partners thanks to Trace for good.",
          "runningJob": "A campaign launch is currently in progress. To uphold the highest standards and ensure the integrity of your data, only one campaign can be launched at a time. Please check back shortly to trace new products with confidence."
        },
        "title": "Traceability Campaign"
      },
      "pendingProducts": {
        "infoBox": {
          "description": {
            "multiple": "The information needed to launch the traceability campaign is missing for {{pendingProductsCount}} products. You can add its procurement details and/or detailed compositions from the Data Hub.",
            "single": "The information needed to launch the traceability campaign is missing for 1 product. You can add its procurement details and/or detailed compositions from the Data Hub."
          },
          "title": {
            "multiple": "{{pendingProductsCount}} pending products",
            "single": "1 pending product"
          }
        }
      },
      "success": {
        "button": "Go to products catalog",
        "description": "Your traceability campaign has been launched successfully. your products are currently being traced to support your CSR strategy and legal compliance.",
        "title": "Traceability campaign launched"
      }
    }
  },
  "maxError": "Must be less than or equal to {{max}}",
  "minError": "Must be greater than or equal to {{min}}",
  "operation": {
    "component": "Component",
    "duplicateProductionSite": "While submission remains possible, be aware other steps have been declared on this site.",
    "material": "Material",
    "notOwner": "Request transferred to {{email}}.",
    "product": "Product",
    "purchaseOrderRef": "Transaction ID (PO or invoice)",
    "reference": "Reference",
    "unknown": "Other"
  },
  "operationNotCreated": "An error occurred",
  "operationNotCreatedMessage": "The information request for this request has not yet been created, please contact support at support@traceforgood.com",
  "prodsiterequest": {
    "actions": {
      "transfer": "Transfer",
      "transferAll": "Transfer all"
    },
    "noRequests": {
      "closed": "You have no completed production site requests.",
      "open": "You have no pending production site requests."
    },
    "status": {
      "INVALID": "Incomplete",
      "TOBESUBMITTED": "Ready to submit"
    },
    "transferModal": {
      "success_one": "{{count}} production site request successfully transferred",
      "success_many": "{{count}} production site requests successfully transferred",
      "success_other": "{{count}} production site requests successfully transferred",
      "title": "Production site request",
      "transferButton": "Transfer"
    }
  },
  "productionSiteSelect": {
    "labels": {
      "addNewProductionSite": "Add a production site",
      "productionSite": "Production site"
    },
    "placeholders": {
      "productionSite": "Search"
    }
  },
  "reopenRequest": {
    "error": "Failed to reopen the request.",
    "feedback_one": "{{count}} sub-request canceled",
    "feedback_many": "{{count}} sub-requests canceled",
    "feedback_other": "{{count}} sub-requests canceled",
    "title": "Are you sure you want to reopen this request? (this action will cancel all sub-requests for this request)",
    "yes": "Reopen"
  },
  "request": {
    "complete": "Submit completed requests",
    "completeTooltip": "Click here to complete and close the request. Any transferred sub-requests will be forwarded to the assigned recipient.",
    "errors": {
      "generic": "Requests could not be retrieved. Please try again later."
    },
    "incomplete": "Incomplete",
    "labels": {
      "composition": "Composition",
      "requestDate": "Request date"
    },
    "readyToSubmit": "Ready to submit",
    "seeLess": "Hide request",
    "seeMore": "Show request"
  },
  "requests": {
    "noRequests": {
      "closed": "No completed requests yet. Look out for open ones!",
      "open": "Congratulations! You have no pending traceability requests."
    },
    "tabs": {
      "canceled": "Canceled",
      "certificates": {
        "scope": "Certificates & Audits",
        "transaction": "Transaction proofs"
      },
      "closed": "Completed",
      "prodsitefield": "Production sites",
      "traceability": "Traceability"
    }
  },
  "requiredError": "Required field",
  "selectAll": "Select all",
  "sorts": {
    "client": "Client",
    "dueDate": "Due date",
    "orderDate": "Order date",
    "receptionDate": "Reception date",
    "reference": "Reference"
  },
  "status": {
    "NOT_UPLOADED": "",
    "PROCESSED": "Uploaded",
    "REJECTED": "",
    "UPLOADED": "Uploaded"
  },
  "submitModal": {
    "composition": "Components",
    "confidenceStatement": "I hereby certify on my honor that the provided information is accurate and complete.",
    "confirmation_one": "{{count}} response successfully submitted",
    "confirmation_many": "{{count}} responses successfully submitted",
    "confirmation_other": "{{count}} responses successfully submitted",
    "error": "Failed to submit responses",
    "noRequests": "No eligible requests on this page",
    "reference": "Reference",
    "submitButton": "Confirm ({{ itemCount }})",
    "title": "Select all the requests that you wish to submit",
    "type": "Type"
  },
  "supplierSettings": {
    "filters": {
      "productionSite": "Production site",
      "status": "Status",
      "tags": "Tags"
    }
  },
  "tooltips": {
    "contact": "The person responsible for the information provided.",
    "productionSite": "A registered location from your repository where manufacturing or processing occurs. Each site is typically linked to a single production flow unless integrated with multiple operations.",
    "purchaseOrderRef": "Purchase order or invoice number associated with this {{type}}.",
    "reference": "Identifier of the concerned product, component, or material."
  },
  "transferModal": {
    "success": "Certificate request transferred successfully",
    "title": "Select the contact to transfer the certificate request to"
  },
  "uniqueActivitiesLabels": {
    "accessoryProvider": "Accessory provider",
    "accessoryRawMaterialProvider": "Raw material provider",
    "apparel": {
      "duvet": {
        "baffle": "Baffle",
        "farm": "Breeding farm (duvet)",
        "materialProduction": "Raw material (duvet)",
        "preProcessor": "Pre-processing"
      },
      "fabric": {
        "appret": "Finishing (fabric)",
        "coating": "Coating (fabric)",
        "dyeing": "Dyeing/Printing (fabric)",
        "lamination": "Lamination",
        "materialProduction": "Raw material (fabric)",
        "spinning": "Spinning (fabric)",
        "weavingKnitting": "Weaving/Knitting"
      },
      "leather": {
        "appret": "Finishing (leather)",
        "dyeing": "Dyeing (leather)",
        "farm": "Breeding farm (leather)",
        "materialProduction": "Slaughterhouse",
        "tanning": "Tanning"
      },
      "manufacturing": "Manufacturing (apparel)",
      "yarn": {
        "dyeing": "Dyeing (yarn)",
        "materialProduction": "Raw material (yarn)",
        "spinning": "Spinning (yarn)"
      }
    },
    "brand": "Brand",
    "certifiedEntity": "Certified entity",
    "footwear": {
      "assembling": "Assembling",
      "finishing": "Finishing",
      "stitching": "Stitching"
    },
    "noActivity": "No activity",
    "paper": {
      "assembling": "Paper assembly",
      "bleaching": "Bleaching",
      "chemicalTreatment": "Chemical treatment",
      "laminating": "Laminating",
      "manufacturing": "Manufacturing (paper)",
      "pressing": "Pressing",
      "printing": "Printing",
      "resineRemoving": "Resine removing",
      "whiteWashing": "White washing"
    },
    "product": {
      "productWashing": "Product washing",
      "washing": "Washing"
    },
    "wood": {
      "assembling": "Wood assembly",
      "brushing": "Brushing",
      "calibrationAndCollage": "Calibration and collage",
      "harvesting": "Harvesting",
      "manufacturing": "Wood manufacturing",
      "materialDrying": "Drying",
      "materialPeeking": "Peeking",
      "materialPeeling": "Peeling",
      "materialSawing": "Sawing",
      "sanding": "Sanding"
    }
  }
}
